import classNames from 'classnames/bind';

import React, { FC, HTMLAttributes } from 'react';

import styles from './Typography.module.scss';

const cx = classNames.bind(styles);

const Caption: FC<HTMLAttributes<HTMLElement>> = ({ children, className, ...props }) => {
  const classes = cx('caption', className);

  return (
    <small className={classes} {...props}>
      {children}
    </small>
  );
};

export default Caption;
